// extracted by mini-css-extract-plugin
export default {"sectionTitle":"styles_sectionTitle__9tbp8","flexContainer":"styles_flexContainer__tCElL"};